import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa"; // Icons for mobile menu

// Styled Components
const Nav = styled.nav`
  background: navy;
  color: #D4AF37;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  max-width: 100vw;
  z-index: 1000;
  box-shadow: 0px 4px 15px rgba(212, 175, 55, 0.5);
  border-bottom: 3px solid #D4AF37;
  overflow-x: hidden;
`;

const NavContainer = styled.div`
  display: flex;
  width: 95%;
  align-items: center;
`;

const Logo = styled(Link)`
  font-size: 2rem;
  font-weight: bold;
  color: #D4AF37;
  text-decoration: none;
  text-transform: uppercase;
  font-family: "Georgia", serif;
  letter-spacing: 2px;
  flex-grow: 1; /* Pushes nav links to the right */
  transition: all 0.3s ease-in-out;

  &:hover {
    color: white;
    text-shadow: 0px 0px 10px rgba(212, 175, 55, 0.8);
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 25px;

  @media (max-width: 768px) {
    display: none;  /* Hide on mobile */
  }
`;

const NavLink = styled(Link)`
  color: #D4AF37;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: bold;
  transition: all 0.3s ease-in-out;
  position: relative;

  &:hover {
    color: white;
    text-shadow: 0px 0px 8px rgba(212, 175, 55, 0.9);
  }

  &:after {
    content: "";
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
    height: 3px;
    background: linear-gradient(90deg, #FFD700, #D4AF37);
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover:after {
    transform: scaleX(1);
  }
`;

const MobileMenu = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;

const MenuButton = styled.button`
  background: none;
  border: none;
  color: #D4AF37;
  font-size: 2rem;
  cursor: pointer;
`;

const MobileNavPanel = styled.div`
  position: fixed;
  top: 0;
  right: ${({ open }) => (open ? "0" : "-100%")};
  width: 250px;
  height: 100vh;
  background: navy;
  color: #D4AF37;
  box-shadow: -3px 0px 15px rgba(212, 175, 55, 0.3);
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  padding-top: 60px;
  text-align: center;
`;

const MobileNavLink = styled(Link)`
  color: #D4AF37;
  text-decoration: none;
  font-size: 1.5rem;
  padding: 15px;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: white;
    text-shadow: 0px 0px 8px rgba(212, 175, 55, 0.8);
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 20px;
  background: none;
  border: none;
  color: #D4AF37;
  font-size: 2rem;
  cursor: pointer;
`;

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <Nav>
      <NavContainer>
        {/* Logo */}
        <Logo to="/">SOMA</Logo>

        {/* Desktop Navigation */}
        <NavLinks>
          <NavLink to="/">Inicio</NavLink>
          <NavLink to="/quienessomos">Quienes Somos</NavLink>
          <NavLink to="/services">Servicios</NavLink>
          <NavLink to="/contact"> Contáctanos</NavLink>
        </NavLinks>

        {/* Mobile Menu Button */}
        <MobileMenu>
          <MenuButton onClick={() => setMenuOpen(true)}>
            <FaBars />
          </MenuButton>
        </MobileMenu>
      </NavContainer>

      {/* Mobile Sidebar */}
      <MobileNavPanel open={menuOpen}>
        <CloseButton onClick={() => setMenuOpen(false)}>
          <FaTimes />
        </CloseButton>
        <MobileNavLink to="/" onClick={() => setMenuOpen(false)}>Home</MobileNavLink>
        <MobileNavLink to="/quienessomos" onClick={() => setMenuOpen(false)}>QuienesSomos</MobileNavLink>
        <MobileNavLink to="/services" onClick={() => setMenuOpen(false)}>Services</MobileNavLink>
        <MobileNavLink to="/contact" onClick={() => setMenuOpen(false)}>Contact</MobileNavLink>
      </MobileNavPanel>
    </Nav>
  );
}

export default Navbar;
